/* global window */
export const cssPrefix = 'fin-cell';
export const look = ['*悬浮查看*', '*HYPERLINK*', '*MULTIPLECELLS*'];
export const look2 = '#CHECK！';
export const filterFormula = ['CITY'];
export const offsetLeft = 60;
export const offsetTop = 70;

export const DELETE = {
    COL: "DELETE COL",
    ROW: "DELETE ROW",
};

export const INSERT = {
    COL: "INSERT COL",
    ROW: "INSERT ROW",
}

// export const edgeRight = 30;
// export const dpr = window.devicePixelRatio  || 1;
// export const dpr = 1;
